import React, { useEffect } from "react";

export default function Redirect(props) {
  const url = props.action;

  useEffect(() => {
    window.location.href = url;
  }, [url]);
  return <></>;
}
